import { useEffect, useState } from 'react';
import { findMarket } from '@/utils/markets';

const KEY = 'discover_market';
const DEFAULT_MARKET = 'Sweden';

/**
 * A stored Discover market as its list name: "Sweden", "SE" and "UK" read as "Sweden", "Sweden" and "United Kingdom".
 * An unknown value falls back to Sweden.
 */
export function discoverMarketFromStorage(stored: string | null | undefined): string {
  return findMarket(stored)?.label ?? DEFAULT_MARKET;
}

/** The Discover market as stored now (read once; Hook Studio reads it without the picker). */
export function readDiscoverMarket(): string {
  try { return discoverMarketFromStorage(localStorage.getItem(KEY)); } catch { return DEFAULT_MARKET; }
}

/**
 * The market shared by the Discover pages (support #238), as its list NAME ("Belgium", "United Kingdom"): cowork repeats
 * it in text people read and in model prompts, and maps every list name to its code where it files by market.
 * Remembered across the pages in localStorage.
 */
export function useDiscoverMarket(): { market: string; setMarket: (name: string) => void } {
  const [market, setMarket] = useState(readDiscoverMarket);
  useEffect(() => { try { localStorage.setItem(KEY, market); } catch { /* storage off */ } }, [market]);
  return { market, setMarket };
}
